import { useEffect, useState } from "react";
import { Save, Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import PageHeader from "@/components/PageHeader";
import { adminApi } from "@/lib/api";

export default function AdminBackupEmails() {
  const [state, setState] = useState({
    email_depot: "",
    email_restitution: "",
    email_delivrance: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi
      .backupEmails()
      .then((d) =>
        setState({
          email_depot: d.email_depot || "",
          email_restitution: d.email_restitution || "",
          email_delivrance: d.email_delivrance || "",
        }),
      )
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await adminApi.updateBackupEmails(state);
      toast.success("Emails de sauvegarde enregistrés");
    } catch (err) {
      toast.error("Erreur");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="p-8 text-[var(--vidoc-text-secondary)]">Chargement...</div>;

  return (
    <div data-testid="admin-backup-emails-page">
      <PageHeader
        title="Emails de sauvegarde"
        subtitle="Reçoivent une copie de chaque PDF généré"
      />

      <div className="px-4 md:px-8 py-6 max-w-2xl space-y-4">
        <p className="text-sm text-[var(--vidoc-text-secondary)]">
          Configurez les adresses qui recevront les copies de sauvegarde pour
          chaque type d'opération. Ces emails sont indépendants du destinataire
          principal du PDF.
        </p>

        {[
          { key: "email_depot", label: "Dépôts" },
          { key: "email_restitution", label: "Restitutions" },
          { key: "email_delivrance", label: "Délivrances" },
        ].map((f) => (
          <div key={f.key} className="bg-white rounded-xl border border-[var(--vidoc-border)] p-4">
            <label className="block">
              <div className="text-sm font-semibold mb-2 flex items-center gap-2">
                <Mail className="w-4 h-4 text-[var(--vidoc-primary)]" />
                {f.label}
              </div>
              <input
                data-testid={`backup-${f.key}`}
                type="email"
                value={state[f.key]}
                onChange={(e) => setState({ ...state, [f.key]: e.target.value })}
                placeholder="archives@vaevidoc.com"
                className="w-full px-3 py-2.5 rounded-lg bg-[var(--vidoc-bg-secondary)] outline-none focus:bg-white focus:ring-2 ring-[var(--vidoc-primary)]"
              />
            </label>
          </div>
        ))}

        <button
          data-testid="backup-emails-save-btn"
          onClick={handleSave}
          disabled={saving}
          className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-[var(--vidoc-primary)] text-white font-semibold touch-target hover:bg-[var(--vidoc-primary-dark)] disabled:opacity-50"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Enregistrer
        </button>
      </div>
    </div>
  );
}
